module.exports = __webpack_public_path__ + "img/logo.9cbf2b46.svg";